import { Tooltip } from '@mui/material';
import { Done, DoneAll, HighlightOff } from '@mui/icons-material';
import { BLUE_COLOR, GREEN_BAR_COLOR } from '@constants/charts';
import { ValidReportStatus } from '../slice/schemas/schema';
import { approvedStatuses } from './CampaignData';

const ICON_BY_STATUS = {
  approved: <DoneAll sx={{ color: GREEN_BAR_COLOR }} />,
  approved_visit_metrics: <Done sx={{ color: BLUE_COLOR }} />,
  fallback: <HighlightOff />,
};

const iconFromStatus = (status: ValidReportStatus) =>
  approvedStatuses.includes(status)
    ? ICON_BY_STATUS[status as keyof typeof ICON_BY_STATUS]
    : ICON_BY_STATUS.fallback;

const HUMAN_STATUS_BY_API_STATUS: Record<
  NonNullable<ValidReportStatus>,
  string
> = {
  approved: 'Approved',
  approved_visit_metrics: 'Approved Visit Metrics',
  pending: 'Pending',
  failed: 'Failed',
};

type ReportStatusIconProps = {
  latestReportStatus: NonNullable<ValidReportStatus>;
};

export const ReportStatusIcon = (props: ReportStatusIconProps) => {
  const Icon = iconFromStatus(props.latestReportStatus);
  const tooltipText = HUMAN_STATUS_BY_API_STATUS[props.latestReportStatus];

  return (
    <Tooltip placement="top" title={tooltipText}>
      {Icon}
    </Tooltip>
  );
};
